import { Inject, Injectable, Optional, inject } from "@angular/core";
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { Observable, firstValueFrom, map } from "rxjs";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Meta, Title } from "@angular/platform-browser";
import { REQUEST } from "@nguniversal/express-engine/tokens";
import { Request } from "express";
import { SeoService } from "src/app/services/seo.service";

@Injectable({ providedIn: "root" })
export class HomeResolver implements Resolve<any> {
  afs = inject(AngularFirestore);
  constructor(
    private meta: Meta, // private socialService: SocialService,
    private title: Title,
    public router: Router,
    private seo: SeoService
  ) { }
  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    this.populateMetaTags();
    return;
  }

  populateMetaTags() {
    //console.log(route.paramMap);
    const title = "Illusbook - Design Faster with Stunning Illustrations";
    const desc =
      "Illusbook offers a collection of stunning illustrations. Browse and download the perfect illustrations for your projects today.";
    const image = "../../../../assets/img/illusbook.png";
    const fullURL = `https://illusbook.com/`;
    //console.log("Window URL:", fullURL);
    this.title.setTitle(`${title}`);
    this.setMetaTag("name", "title", title);
    this.setMetaTag("name", "description", desc);
    this.setMetaTag("name", "og:title", title);
    this.setMetaTag("property", "og:title", title);
    this.setMetaTag("property", "og:description", desc);
    this.setMetaTag("property", "og:image", image);
    this.setMetaTag("property", "og:url", fullURL);
    this.setMetaTag("property", "og:type", "website");
    this.setMetaTag("property", "og:site_name", "Illusbook");
    this.setMetaTag("name", "twitter:card", "summary_large_image");
    this.setMetaTag("name", "twitter:title", title);
    this.setMetaTag("name", "twitter:description", desc);
    this.setMetaTag("name", "twitter:image", image);

    this.seo.setJSONLD([{
      "@context": "https://schema.org/",
      "@type": "Organization",
      "@id": "https://illusbook.com/#organization",
      url: fullURL,
      "sameAs": [
        "https://www.linkedin.com/company/illusbook/",
        "https://www.instagram.com/illusbook/",
        "https://x.com/illusbook",
        "https://www.pinterest.com/illusbook/"
      ],
      logo: "https://illusbook.com/assets/favicon/android-icon-192x192.png",
      "name": "Illusbook",
      description: desc,
      "email": "support@illusbook.com",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "135, Greenfield's Crown City, Phase II, Sathy Main Road, Kovilpalayam",
        "addressLocality": "Coimbatore",
        "addressCountry": "IN",
        "addressRegion": "Tamil Nadu",
        "postalCode": "641107"
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": "https://illusbook.com/#website",
      "url": "https://illusbook.com",
      "name": "Illusbook",
      "publisher": {
        "@id": "https://illusbook.com/#organization"
      },
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://illusbook.com/search?value={search_term_string}&searchKey=Illustration",
        "query-input": "required name=search_term_string"
      }

    }
    ]);
  }





  setMetaTag(
    attrName: "name" | "property",
    attrValue: string,
    content: string
  ) {
    const selector = `${attrName}="${attrValue}"`;
    //console.log(selector);
    this.meta.removeTag(selector);
    this.meta.addTag({ [attrName]: attrValue, content });
    // this.meta.updateTag({ [attrName]: attrValue, content });
  }
}
